import { render, staticRenderFns } from "./_Search.vue?vue&type=template&id=ecd5141e&scoped=true&"
import script from "./_Search.vue?vue&type=script&lang=js&"
export * from "./_Search.vue?vue&type=script&lang=js&"
import style0 from "./_Search.vue?vue&type=style&index=0&id=ecd5141e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd5141e",
  null
  
)

export default component.exports